import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'

class CloudwaysCompleted extends React.Component {
	render() {
		const { migrate } = this.props
		return <div className="cws d-flex">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="migration-box text-center">
							<div>
								<img className="bv-logo" src="/assets/blog-vault-logo@2x.png" alt=""/>
								<h1 className="font-36 color-0E134F proxima-regular mt-1 mb-2">Your migration is complete!</h1>
								<p className="v-center py-1 site-urls" style={{justifyContent: 'center'}}>
									<a href={migrate.get('source_site')} target="_blank" rel="noreferrer" className="color-2D38BB proxima-regular font-18 td-none">
										{migrate.get('source_site')}
									</a>
									<img className="arrow-icon" src="/assets/cloudways/cws-blue-arrow.svg" alt=""/>
									<a href={migrate.get('destination_site')} target="_blank" rel="noreferrer" className="color-2D38BB proxima-regular font-18 td-none">
										{migrate.get('destination_site')}
									</a>
								</p>
							</div>
							<div className="cw-border-1 mt-2 mb-4"/>
							<div className="mt-5 mb-5 migrate-process-box">
								<h6 className="font-16  color-0E134F proxima-regular fw-600">What you have to do now </h6>
								<div className="d-flex align-items-center justify-content-center mt-2 mb-2 flex-n-500">
									<div className="steps-complete d-flex align-items-center justify-content-center  ">
										<img className="mr-1" src="/assets/cloudways/cws-connect.svg"/>
										<h6 className="font-14 color-42526E proxima-regular">Connect your Domain</h6>
									</div>
									<div className="ml-1 mr-1 mt-1 mb-1">
										<img src="/assets/cloudways/cws-right-arrow.svg"/>
									</div>
									<div className="steps-complete d-flex align-items-center justify-content-center ">
										<img className="mr-1" src="/assets/cloudways/cws-enable.svg"/>
										<h6 className="font-14 color-42526E proxima-regular">Enable SSL</h6>
									</div>
									<div className="ml-1 mr-1 mt-1 mb-1">
										<img src="/assets/cloudways/cws-right-arrow.svg"/>
									</div>
									<div className="steps-complete d-flex align-items-center justify-content-center ">
										<img className="mr-1" src="/assets/cloudways/cws-configure.svg"/>
										<h6 className="font-14 color-42526E proxima-regular">Configure Settings</h6>
									</div>
								</div>
								<h6 className="font-13 color-42526E  proxima-regular">
									Navigate through your Cloudways-hosted site for quality assurance. If anything is a miss,<br/>
									drop us a line via a <a href="https://support.cloudways.com/" target="_blank" rel="noreferrer" className="color-2D38BB">
										Support Ticket.
									</a>
								</h6>
								<a href={migrate.get('destination_site')} target="_blank" rel="noreferrer" className="green-button mt-5 border-none inline-block">
									GO TO CLOUDWAYS
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}

CloudwaysCompleted.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default CloudwaysCompleted
